//planets textures
import mercury_map from "../../../assets/textures/mercury/mercury_map.jpg";
import mercury_bump_map from "../../../assets/textures/mercury/mercury_bump_map.jpg"; 

import venus_map from "../../../assets/textures/venus/venus_map.jpg";
import venus_atm_map      from '../../../assets/textures/venus/venus_atm_map.jpg';


import pso_map from "../../../assets/textures/psoj138/psoj_map.png";

import earth_map from "../../../assets/textures/earth/earth_map.jpg";
import earth_specular_map from '../../../assets/textures/earth/earth_specular_map.png';
import earth_night_map    from '../../../assets/textures/earth/earth_night_map.jpg';
import earth_normal_map        from '../../../assets/textures/earth/earth_normal_map.png';
import earth_clouds_map         from '../../../assets/textures/earth/earth_clouds_map.jpg';



import moon_map from "../../../assets/textures/earth/moons/Moon/moon_map.jpg";
import moon_normal_map      from '../../../assets/textures/earth/moons/Moon/moon_normal_map.jpg';

import mars_map from "../../../assets/textures/mars/mars_map.png";
import mars_bump_map from "../../../assets/textures/mars/mars_bump_map.png";

//saturn and moons
import saturn_map from "../../../assets/textures/saturn/saturn_map.jpg"; 
import dione_map from "../../../assets/textures/saturn/moons/Dione/dione_map.png"; 
import iapetus_map from "../../../assets/textures/saturn/moons/Iapetus/iapetus_map.png"; 
import rhea_map from "../../../assets/textures/saturn/moons/Rhea/rhea_map.jpg"; 
import titan_map from "../../../assets/textures/saturn/moons/Titan/titan_map.png";  
import tethys_map from "../../../assets/textures/saturn/moons/Thetys/tethys_map.png";  
import mimas_map from "../../../assets/textures/saturn/moons/Mimas/mimas_map.png";

import dione_bump_map from "../../../assets/textures/saturn/moons/Dione/dione_bump_map.png";
import iapetus_bump_map from "../../../assets/textures/saturn/moons/Iapetus/iapetus_bump_map.png";
import rhea_bump_map from "../../../assets/textures/saturn/moons/Rhea/rhea_bump_map.png";
import titan_bump_map from "../../../assets/textures/saturn/moons/Titan/titan_bump_map.png";
import tethys_bump_map from "../../../assets/textures/saturn/moons/Thetys/tethys_bump_map.jpg";
import mimas_bump_map from "../../../assets/textures/saturn/moons/Mimas/mimas_bump_map.jpg";

//jupiter and moons
import jupiter_map from "../../../assets/textures/jupiter/jupiter_map.jpg";
import europa_map from "../../../assets/textures/jupiter/moons/Europa/europa_map.jpg";
import callisto_map from "../../../assets/textures/jupiter/moons/Callisto/callisto_map.jpg";
import ganymede_map from "../../../assets/textures/jupiter/moons/Ganymede/ganymede_map.jpg";
import io_map from "../../../assets/textures/jupiter/moons/io/io_map.jpeg";


import europa_bump_map from "../../../assets/textures/jupiter/moons/Europa/europa_bump_map.png";
import callisto_bump_map from "../../../assets/textures/jupiter/moons/Callisto/callisto_bump_map.jpg";
import ganymede_bump_map from "../../../assets/textures/jupiter/moons/Ganymede/ganymede_bump_map.jpg";
import io_bump_map from "../../../assets/textures/jupiter/moons/io/io_bump_map.png";




//rings of planets
import rings_saturn_map from "../../../assets/textures/saturn/rings/saturn-rings.png";
import rings_uranus_map from "../../../assets/textures/uranus/rings/uranus_rings.png";
import rings_jupiter_map from "../../../assets/textures/jupiter/rings/jupiter_rings.png";
import rings_neptune_map from "../../../assets/textures/neptune/rings/neptune_rings.png";

//uranus and moons
import uranus_map from "../../../assets/textures/uranus/uranus_map.jpg";
import titania_map from "../../../assets/textures/uranus/moons/Titania/titania_map.png";
import umbriel_map from "../../../assets/textures/uranus/moons/Umbriel/umbriel_map.png";
import oberon_map from "../../../assets/textures/uranus/moons/Oberon/oberon_map.png";
import ariel_map from "../../../assets/textures/uranus/moons/Ariel/ariel_map.png";
import miranda_map from "../../../assets/textures/uranus/moons/Miranda/miranda_map.png";

import titania_bump_map from "../../../assets/textures/uranus/moons/Titania/titania_bump_map.png";
import umbriel_bump_map from "../../../assets/textures/uranus/moons/Umbriel/umbriel_bump_map.png";
import oberon_bump_map from "../../../assets/textures/uranus/moons/Oberon/oberon_bump_map.png";
import ariel_bump_map from "../../../assets/textures/uranus/moons/Ariel/ariel_bump_map.png";
import miranda_bump_map from "../../../assets/textures/uranus/moons/Miranda/miranda_bump_map.png";


//neptune and moons
import neptune_map from "../../../assets/textures/neptune/neptune_map.jpg"; 
import triton_map from "../../../assets/textures/neptune/moons/Triton/triton_map.jpg"; 

import triton_bump_map from "../../../assets/textures/neptune/moons/Triton/triton_bump_map.jpg";

//pluto and moons
import pluto_map from "../../../assets/textures/pluto/pluto_map.png"; 
import pluto_bump_map from "../../../assets/textures/pluto/pluto_bump_map.jpg"; 
import charon_map from "../../../assets/textures/pluto/moons/Charon/charon_map.jpg"; 
import charon_bump_map from "../../../assets/textures/pluto/moons/Charon/charon_bump_map.png";


const distSargitarius = 26490 * 63241.1 * 23.4117;
const distSargitariusNeutron = 26520 * 63241.1 * 23.4117;
const distPso = -26385 * 63241.1 * 23.4117;
export const celestialData = {
  blackhole: {
    size: 8.05,
    label: "Sagittarius A*",
    children: {
      Sun: {
        type: "star",
        size: 1.0929e-1,
        orbitRadius: -distSargitarius,
        axialTilt: 0.1265364,
        orbitInclin: 0,
        speedTrans: -9.016846e-11,
        speedRot: 2.916846e-1,
        eccentricity: 0,
        name: "Sun",
        children: {
          Mercury: {
            type: "planet",
            size: 3.83e-4,
            texture: {map:mercury_map,
                      bump_map:mercury_bump_map,
                      displac_map:false},
            orbitRadius: 9.09058,
            axialTilt: 0.034,
            orbitInclin: 0.12,
            speedTrans: 8.264e-2,
            speedRot: 1.24e-1,
            eccentricity: 0.2056,
            argPeriapsis: 0.5083,
            longAscNode: 0.84351763,
            label: "Mercury",
            children: {},
          },
          Venus: {
            type: "planet",
            size: 9.5e-4,
            texture: {map:venus_map,
                      atm_map:venus_atm_map
            },
            orbitRadius: 16.986,
            axialTilt: 177.4,
            orbitInclin: 0.059236,
            speedTrans: 3.232e-2,
            speedRot: 2.99259e-2,
            eccentricity: 0.0068,
            argPeriapsis: 0.9579,
            longAscNode: 1.338,
            label: "Venus",
            children: {},
          },
          Earth: {
            type: "planet",
            size: 1e-3,
              texture: {map:earth_map,
                        normalmap:earth_normal_map,
                        specularmap: earth_specular_map,
                        nightmap:earth_night_map,
                        cloudsmap: earth_clouds_map},
            orbitRadius: 23.47,
            axialTilt: 23.44,
            orbitInclin: 0,
            speedTrans: 1.992e-2,
            speedRot: 7.2921,
            eccentricity: 0.0167,
            argPeriapsis: 1.993,
            longAscNode: 0.1965,
            label: "Earth",
            children: {
              Moon: {
                type: "satellite",
                size: 2.73e-4,
                texture: {map:moon_map,
                          normal_map:moon_normal_map},
                orbitRadius: 6.0335e-2,
                axialTilt: 18.28,
                orbitInclin: -0.08972,
                speedTrans: 2.6617e-1,
                speedRot: 2.6617e-1,
                eccentricity: 0.0549,
                argPeriapsis: 0.7101,
                longAscNode: 0.3377,
                label: "Moon",
              },
            },
          },
          Mars: {
            type: "planet",
            size: 5.319e-4,
            texture: {map:mars_map,
                      bump_map:mars_bump_map,
                      displac_map:false},
            orbitRadius: 35.743,
            axialTilt: 25.19,
            orbitInclin: 0.03228859,
            speedTrans: 1.059e-2,
            speedRot: 7.0882,
            eccentricity: 0.0934,
            argPeriapsis: 5,
            longAscNode: 0.8653,
            label: "Mars",
            children: {
            },
          },
          Jupiter: {
            type: "planet",
            size: 1.12e-2,
            texture: {map:jupiter_map},
            orbitRadius: 122.153,
            axialTilt: 3.12,
            orbitInclin: 0.0228289,
            speedTrans: 1.673e-3,
            speedRot: 1.7734e1,
            eccentricity: 0.0484,
            argPeriapsis: 4.7798,
            longAscNode: 1.753,
            label: "Jupiter",
            ring: {
                innerRadius: 1.444e-2,  
                outerRadius: 1.924e-2,
                texture: rings_jupiter_map,
                shadow:false
            },
            children: {
              Europa: {
                type: "satellite",
                size: 2.45e-4,
                texture: {map:europa_map,
                          bump_map:europa_bump_map,
                         displac_map:false},
                orbitRadius: 1.0538e-1,
                axialTilt: 0.470,
                orbitInclin: 0.008203,
                speedTrans: 2.053433773,
                speedRot: 2.053715175,
                eccentricity: 0.0094,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Europa",
              },
              Callisto: {
                type: "satellite",
                size: 3.78e-4,
                texture: {map:callisto_map,
                          bump_map:callisto_bump_map,
                          displac_map:false},
                orbitRadius: 2.9595e-1,
                axialTilt: 0.192,
                orbitInclin: 0.0033510322,
                speedTrans: 4.369409e-1,
                speedRot: 4.369445e-1,
                eccentricity: 0.0074,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Callisto",
              },
              Ganymede: {
                type: "satellite",
                size: 4.13e-4,
                texture: {map:ganymede_map,
                          bump_map:ganymede_bump_map,
                          displac_map:false},
                orbitRadius: 1.6848e-1,
                axialTilt: 0.177,
                orbitInclin: 0.00349066,
                speedTrans: 1.019227339,
                speedRot: 1.019227339,
                eccentricity: 0.0013,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Ganymede",
              },
              Io: {
                type: "satellite",
                size: 2.86e-4,
                texture: {map:io_map,
                          bump_map:io_bump_map,
                          displac_map:false},
                orbitRadius: 6.623e-2,
                axialTilt: 	0.038,
                orbitInclin: 0.00087,
                speedTrans: 4.12,
                speedRot: 4.129,
                eccentricity: 0.004,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Io",
              },
            },
          },
          Saturn: {
            type: "planet",
            size: 9.45e-3,
            texture: {map:saturn_map},
            orbitRadius: 224.107,
            axialTilt: 26.73,
            orbitInclin: 0.04342,
            speedTrans: 9.294e-4,
            speedRot: 1.63624e1,
            eccentricity: 0.0541,
            argPeriapsis: 5.9235,
            longAscNode: 1.983,
            label: "Saturn",
            ring: {
              innerRadius: 1.050e-2,
              outerRadius: 2.200e-2,
              texture: rings_saturn_map,
              shadow:true
            },
            children: {
              Mimas: {
              type: "satellite",
              size: 3.11e-5,
              texture: {
                map: mimas_map,
                bump_map: mimas_bump_map,
                displac_map:mimas_bump_map,
                displac_map:true
              },
              orbitRadius: 2.915e-2,
              axialTilt: 1.57,
              orbitInclin: 0.02742,        
              speedTrans: 7.71,         
              speedRot: 7.71,    
              eccentricity: 0.0196,
              argPeriapsis: 0,
              longAscNode: 0,
              label: "Mimas",
            },
              Dione: {
                type: "satellite",
                size: 8.821e-5,
                texture: {map:dione_map,
                          bump_map:dione_bump_map,
                          displac_map:true},
                orbitRadius: 5.931e-2,
                axialTilt: 0.02,
                orbitInclin: 0.00033,
                speedTrans: 2.664,
                speedRot: 2.664,
                eccentricity: 0.022,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Dione",
              },
              Iapetus: {
                type: "satellite",
                size: 1.15e-4,
                texture: {map:iapetus_map,
                          bump_map:iapetus_bump_map,
                          displac_map:true},
                orbitRadius: 5.5943e-1,
                axialTilt: 15.47,
                orbitInclin: 0.27000244,
                speedTrans: 9.193e-2,
                speedRot: 9.1956e-2,
                eccentricity: 0.0281,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Iapetus",
              },
              Rhea: {
                type: "satellite",
                size: 1.2e-4,
                texture: {map:rhea_map,
                          bump_map:rhea_bump_map,
                          displac_map:true},
                orbitRadius: 8.286e-2,
                axialTilt: 0.345,
                orbitInclin: 0.006021386,
                speedTrans: 1.6139,
                speedRot: 1.614,
                eccentricity: 0.002583,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Rhea",
              },
              Titan: {
                type: "satellite",
                size: 4.06e-4,
                texture: {map:titan_map,
                          bump_map:titan_bump_map,
                          displac_map:false},
                orbitRadius: 1.9205e-1,
                axialTilt: 0.348,
                orbitInclin: 0.0060737,
                speedTrans: 4.9678e-1,
                speedRot: 4.9678e-1,
                eccentricity: 0.0288,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Titan",
              },
              Tethys: {
                type: "satellite",
                size: 8.3098e-5,
                texture: {map:tethys_map,
                          bump_map:tethys_bump_map,
                          displac_map:true},
                orbitRadius: 4.623e-2,
                axialTilt: 1.12,
                orbitInclin: 0.01954769,
                speedTrans: 3.86275,
                speedRot: 3.86275,
                eccentricity: 0.0001,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Tethys",
              },
            },
          },
          Uranus: {
            type: "planet",
            size: 3.98e-3,
            texture: {map:uranus_map},
            orbitRadius: 450.523,
            axialTilt: 97.77,
            orbitInclin: 0.0135,
            speedTrans: 2.37e-4,
            speedRot: 1.041e1,
            eccentricity: 0.0472,
            argPeriapsis: 1.6929,
            longAscNode: 1.2916,
            label: "Uranus",
            ring: {
              innerRadius: 5.96e-3,
              outerRadius: 8.02e-3,
              texture: rings_uranus_map,
              shadow:false
            },
            children: {
              Miranda: {
              type: "satellite",
              size: 3.71e-5,
              texture: {
                map: miranda_map,
                bump_map: miranda_bump_map,
                displac_map:true
              },
              orbitRadius: 2.041e-2,
              axialTilt: 4.338,
              orbitInclin: 0.07568,        
              speedTrans: 5.15,     
              speedRot: 5.15,   
              eccentricity: 0.0013,
              argPeriapsis: 0,
              longAscNode: 0,
              label: "Miranda",
            },
              Titania: {
                type: "satellite",
                size: 1.2369e-4,
                texture: {map:titania_map,
                          bump_map:titania_bump_map,
                          displac_map:true},
                orbitRadius: 6.844e-2,
                axialTilt: 0.079,
                orbitInclin: 0.00244346,
                speedTrans: 0.8376,
                speedRot: 0.8376,
                eccentricity: 0.0022,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Titania",
              },
              Oberon: {
                type: "satellite",
                size: 1.1938e-4,
                texture: {map:oberon_map,
                          bump_map:oberon_bump_map,
                          displac_map:true},
                orbitRadius: 9.14e-2,
                axialTilt: 0.068,
                orbitInclin: 0.001,
                speedTrans: 0.54163,
                speedRot: 0.54163,
                eccentricity: 0.0014,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Oberon",
              },
              Umbriel: {
                type: "satellite",
                size: 9.1675e-5,
                texture: {map:umbriel_map,
                          bump_map:umbriel_bump_map,
                          displac_map:true},
                orbitRadius: 4.174e-2,
                axialTilt: 0.128,
                orbitInclin: 0.006283,
                speedTrans: 1.7596,
                speedRot: 1.7596,
                eccentricity: 0.005,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Umbriel",
              },
              Ariel: {
                type: "satellite",
                size: 9.0765e-5,
                texture: {map:ariel_map,
                          bump_map:ariel_bump_map,
                          displac_map:true},
                orbitRadius: 3e-2,
                axialTilt: 0.041,
                orbitInclin: 0.00541,
                speedTrans: 2.8932,
                speedRot: 2.8932,
                eccentricity: 0.0034,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Ariel",
              },
            },
          },
          Neptune: {
            type: "planet",
            size: 3.85e-3,
            texture: {map:neptune_map},
            orbitRadius: 706.657,
            axialTilt: 28.32,
            orbitInclin: 0.030962,
            speedTrans: 1.208e-4,
            speedRot: 1.08e1,
            eccentricity: 0.0086,
            argPeriapsis: 4.768,
            longAscNode: 2.3,
            label: "Neptune",
            ring: {
               innerRadius: 6.576e-3,
               outerRadius: 9.880e-3,
               texture: rings_neptune_map,
               shadow:false
            },
            children: {
              Triton: {
                type: "satellite",
                size: 2.167e-4,
                texture: {map:triton_map,
                          bump_map:triton_bump_map,
                          displac_map:false},
                orbitRadius: 5.57e-2,
                axialTilt: 156.885,
                orbitInclin: 2.738159,
                speedTrans: 1.2408,
                speedRot: 1.2408,
                eccentricity: 1.6e-5,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Triton",
              },
            },
          },
          Pluto: {
            type: "planet",
            size: 1.9e-4,
            texture: {map:pluto_map,
                          bump_map:pluto_bump_map},
            orbitRadius: 927.7436,
            axialTilt: 119.61,
            orbitInclin: 0.29917997705,
            speedTrans: 8.01e-5,
            speedRot: 1.2956,
            eccentricity: 0.2488,
            argPeriapsis: 1.98677,
            longAscNode: 1.925,
            label: "Pluto",
            children: {
              Charon: {
                type: "satellite",
                size: 9.19e-5,
                texture: {map:charon_map,
                          bump_map:charon_bump_map,
                          displac_map:true},
                orbitRadius: 3.08e-3,
                axialTilt: 0.08,
                orbitInclin: 2.0872567,
                speedTrans: 1.1416,
                speedRot: 1.1416,
                eccentricity: 1.61e-4,
                argPeriapsis: 0,
                longAscNode: 0,
                label: "Charon",
              },
            },
          },
          "Halley's Comet": {
            type: "comet",
            size: 5e-5,
            texture: null,
            orbitRadius: 418.42,
            axialTilt: 162,
            orbitInclin: -2.8326694,
            speedTrans: 2.66e-4,
            speedRot: 0.9854,
            eccentricity: -0.967,
            argPeriapsis: 1.95564,
            longAscNode: 1.0366557,
            label: "Halley's Comet",
          },
        },
      },
      Neutron_Star: {
        type: "neutron",
        size: 5e-3,
        orbitRadius: -distSargitariusNeutron,
        axialTilt: 0.1265,
        orbitInclin: 0,
        speedTrans: -2.5e-10,
        speedRot: 70.33e5,
        eccentricity: 0,
        label: "Neutron Star",
      },
      PSO_J318_5_22: {
        type: "planet",
        size: 1.2, 
        texture: {map:pso_map},
        orbitRadius: distPso,
        axialTilt: 33,
        orbitInclin: 0,
        speedTrans: -1.05e-10,
        speedRot: 2.03e1,
        eccentricity: 0,
        argPeriapsis: 0,
        longAscNode: 0,
        label: "PSO J318.5-22",
      },
    },
  },
  whitehole: {
    type: "whitehole",
    size: 8.05,
    label: "White Hole"
  },
};


